
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { RootState } from '../../../redux/rootReducers'
import { CommonHeader, ErrorSuccessModal, Loader } from '../../../components/commons'
import { DropDownType, GetClientDirectoryListPayloadType } from '../../../commonTypes/clientDirectoryTypes'
import RecurringJobsTable from '../../../components/Jobs/RecurringJobsSetting'
import { getClientDirectoryListAction } from '../../../redux/clientDirectory'
import { ClientDirectoryListType } from '../../../redux/clientDirectory/clientDirectoryType'
import Select from 'react-select'
import useDebounce from '../../../customHooks/useDebounce'
import { addRecurringJobsDetailsAction, getRecurringJobsDetailsAction, resetError, resetFetching, resetRecurringJobsDetailsList, resetStatusCode, resetSuccess } from '../../../redux/jobs'
import { resetSession } from '../../../redux/auth'
import { AddRecurringJobTypePayload, GetRecurringJobsSettingPayload } from '../../../commonTypes/jobsType'

type AppProps = {
    history: any;
    token: string | null;
    error: string | null | undefined;
    success: number | null;
    statusCode: number | null;
    fetching: boolean;
    clientFetching: boolean;
    totalCount: number | null;
    clientDirectoryList: [] | ClientDirectoryListType[];
    singleRecurringJobsDetails: any;
    dispatchGetClientDirectoryListAction: (data: GetClientDirectoryListPayloadType) => void;
    dispatchAddRecurringJobsDetailsAction: (data: AddRecurringJobTypePayload) => void;
    dispatchGetRecurringJobsDetailsAction: (data: GetRecurringJobsSettingPayload) => void;
    dispatchResetSession: () => void;
    dispatchResetSuccess: () => void;
    dispatchResetStatusCode: () => void;
    dispatchResetError: () => void;
    dispatchResetFetching: () => void;
    dispatchResetRecurringJobsDetailsList: () => void;
}
const AddEditRecurringJobSetting = ({
    history,
    token,
    statusCode,
    success,
    fetching,
    error,
    totalCount,
    clientFetching,
    clientDirectoryList,
    singleRecurringJobsDetails,
    dispatchGetClientDirectoryListAction,
    dispatchAddRecurringJobsDetailsAction,
    dispatchResetSession,
    dispatchResetSuccess,
    dispatchResetStatusCode,
    dispatchResetError,
    dispatchGetRecurringJobsDetailsAction,
    dispatchResetRecurringJobsDetailsList,
    dispatchResetFetching
}: AppProps) => {
    const [finalClientList, setFinalClientList] = useState<any>([]);
    const [text, setText] = useState<string>("");
    const [limit, setLimit] = useState<number>(20);
    const [offset, setoffset] = useState<number>(0);
    const [clientName, setClientName] = useState<DropDownType>({
        value: null,
        label: "Select.."
    })
    const [clientCodeError, setClientCodeError] = useState("");
    const [formError, setFormError] = useState(false);
  
    useEffect(() => {
        window.scroll({
            top: 0,
            left: 0
        })
        dispatchResetSuccess();
        dispatchResetError();
        dispatchResetFetching();
        dispatchResetRecurringJobsDetailsList();
    }, [])

    useEffect(() => {
        if (clientName?.value && token) {
            const finalData = {
                token,
                clientCode: clientName?.value
            }
            dispatchGetRecurringJobsDetailsAction(finalData)
        }
    }, [clientName?.value])

    useEffect(() => {
        const finalClientListData = clientDirectoryList?.map((data: any) => {
            return {
                value: data?.client_code,
                label: `(${data?.client_code}) ${data?.company_name}`
            }
        })
        if (offset > 0) {
            setFinalClientList([...finalClientList, ...finalClientListData])
        }
        else {
            setFinalClientList(finalClientListData)
        }
    }, [clientDirectoryList])

    useEffect(() => {
        if (token && totalCount) {
            if (offset <= +totalCount) {
                const finalData = {
                    token,
                    status: 1,
                    offset,
                    limit,
                    searchValue: text,
                }
                dispatchGetClientDirectoryListAction(finalData)
            }
        }
    }, [offset])

    const fetchNewData = () => {
        const finalData = {
            token,
            status: 1,
            offset,
            limit,
            searchValue: text,
        }
        dispatchGetClientDirectoryListAction(finalData)
    }

    useDebounce(() => {
        if (text) {
            fetchNewData()
        }
        else {
            const finalData = {
                token,
                status: 1,
                offset,
                limit,
                searchValue: text,
            }
            dispatchGetClientDirectoryListAction(finalData)
        }
    }, 500, [text])

    const handleClientChanges = (data: any) => {
        setClientName({
            value: data?.value,
            label: data?.label
        })
        setClientCodeError("")
    }

    const checkBottom = (e: any) => {
        setoffset((prv: any) => prv + limit);
    };

    const handleSubmit = (data: any) => {
        window.scroll({
            top: 0,
            left: 0
        })
        let flag = true;
        data?.map((el: any) => {
            if (el?.jobType?.value === null || el?.manager?.value === null || el?.responsible?.value === null) {
                return flag = false
            }
        })

        if (token && clientName?.value && flag) {
            const finalData = {
                token,
                clientCode: +clientName?.value,
                jobDetails: data
            }
            dispatchAddRecurringJobsDetailsAction(finalData)
        }
        else {
            setFormError(true)
            { !clientName?.value && setClientCodeError("Please Select Client!") }
        }
    }
    const handleErrorModal = () => {
        if (success === 0) {
            if (statusCode === 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message="Session Expired. Please Login Again!"
                        buttonText="Logout"
                        onPress={() => dispatchResetSession()}
                        statusCode={statusCode}
                    />
                );
            } else if (error && statusCode !== 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message={error}
                        buttonText="OK"
                        onPress={() => {
                            dispatchResetError();
                        }}
                    />
                );
            }
        }

        if (success === 1) {
            return (
                <ErrorSuccessModal
                    type="success"
                    isOpen={success === 1}
                    title="Success"
                    message={`Client Added Successfully!`}
                    buttonText="OK"

                    onPress={() => {
                        history.push({
                            pathname: `/jobs/recurring-jobs`,
                        })
                        dispatchResetSuccess()
                        dispatchResetError()
                        dispatchResetStatusCode()
                        dispatchResetRecurringJobsDetailsList()
                        setClientName({
                            value: null,
                            label: "Select.."
                        })
                    }}
                    statusCode={statusCode}
                />
            )
        }
    }
    return (
        <>
            <div className='row'>
                <CommonHeader title='Recurring Job Setting' />
            </div>
            <div style={{ backgroundColor: "white", paddingTop: "23px", border: "1px solid #bfcbe1", borderRadius: "6px" }}>
                <div className='row  ml-2'>
                    <div className='col-md-4'>
                        {/* <h5>Recurring Job Setting</h5> */}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-3 ml-4'>
                        <label htmlFor='Select Client' className='mb-2'>Select Client<span style={{ color: "red" }}>*</span></label>
                        <Select
                            options={finalClientList}
                            className={`${clientCodeError ? "error-border rounded" : ""}`}
                            value={clientName}
                            onChange={handleClientChanges}
                            isSearchable={true}
                            isLoading={clientFetching}
                            onMenuClose={() => { setoffset(0) }}
                            onMenuScrollToBottom={(e: any) => checkBottom(e)}
                            onInputChange={(e) => {
                                setText(e)
                            }}
                        />
                        {clientCodeError && (
                            <small className='text-danger'>{clientCodeError ? clientCodeError : ""}</small>
                        )}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <RecurringJobsTable
                            history={history}
                            clientName={clientName}
                            success={success}
                            formError={formError}
                            handleSubmit={handleSubmit}
                            jobDetails={singleRecurringJobsDetails?.job_details}
                        />
                    </div>
                </div>
            </div>
            {handleErrorModal()}
            {fetching && <Loader />}
        </>
    )
}

const mapStateToProps = ((state: RootState) => ({
    clientDirectoryList: state.clientDirectory.clientDirectoryList,
    token: state.auth.token,
    totalCount: state.clientDirectory.totalCount,
    clientFetching: state.clientDirectory.fetching,
    success: state.jobs.success,
    statusCode: state.jobs.statusCode,
    error: state.jobs.error,
    fetching: state.jobs.fetching,
    singleRecurringJobsDetails: state.jobs.singleRecurringJobsDetails
}))

const mapDispatchToProps = ((dispatch: any) => ({
    dispatchGetClientDirectoryListAction: (data: GetClientDirectoryListPayloadType) => dispatch(getClientDirectoryListAction(data)),
    dispatchAddRecurringJobsDetailsAction: (data: AddRecurringJobTypePayload) => dispatch(addRecurringJobsDetailsAction(data)),
    dispatchGetRecurringJobsDetailsAction: (data: GetRecurringJobsSettingPayload) => dispatch(getRecurringJobsDetailsAction(data)),
    dispatchResetSession: () => dispatch(resetSession()),
    dispatchResetSuccess: () => dispatch(resetSuccess()),
    dispatchResetStatusCode: () => dispatch(resetStatusCode()),
    dispatchResetFetching: () => dispatch(resetFetching()),
    dispatchResetRecurringJobsDetailsList: () => dispatch(resetRecurringJobsDetailsList()),
    dispatchResetError: () => dispatch(resetError()),
}))

export default connect(mapStateToProps, mapDispatchToProps)(AddEditRecurringJobSetting)